export default "dist/images/title.png"